import * as url from "../../helpers/url_helper";
import { apiCall } from "./apiService";

/**
 * Updates store created_at date
 * @param {string} storeDomain - Store domain
 * @param {string} createdAt - Created at date (YYYY-MM-DD format)
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<Object|null>} Response data or null if error
 */
export const updateStoreCreatedAt = async (storeDomain, createdAt, notifyError) => {
    return await apiCall(
        url.PUT_UPDATE_STORE,
        'PUT',
        {
            store_domain: storeDomain,
            created_at: createdAt,
        },
        notifyError,
        "Failed to update store created date"
    );
};

